var _defs, _g, _path, _path2, _g2, _path3, _g3, _path4, _path5, _g4, _g5, _g6, _path6, _g7, _g8, _g9, _g10, _g11, _path7, _g12, _g13, _path8, _g14, _g15, _g16, _g17, _path9, _path10, _path11, _g18, _path12, _g19, _path13, _g20, _g21, _path14, _g22, _path15, _g23, _path16, _g24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.285,
    height: 108.107,
    viewBox: "0 0 149.285 108.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.499,
    cy: 0.5,
    r: 0.424,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#e9e9f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9997c6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122542",
    "data-name": "Path 122542",
    d: "M324.1,299.171a18.341,18.341,0,1,1-25.628-4A18.341,18.341,0,0,1,324.1,299.171Z",
    transform: "translate(-290.944 -291.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.432,
    cy: 0.438,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#fefefe",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#fbfbfb",
    stopOpacity: 0.941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#f7f7f6",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#f0f0f0",
    stopOpacity: 0.761
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#e8e8e8",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#dfdfde",
    stopOpacity: 0.463
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#d3d3d2",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    stopColor: "#c6c6c5",
    stopOpacity: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.491,
    cy: 0.47,
    r: 0.404,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#f1f1f1",
    stopOpacity: 0.773
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#d0d0cf",
    stopOpacity: 0.204
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4c4c3",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116494",
    "data-name": "Group 116494",
    transform: "translate(-35.846 -149.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116493",
    "data-name": "Group 116493",
    transform: "translate(35.846 149.357)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116417",
    "data-name": "Group 116417",
    transform: "translate(108.58 8.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116411",
    "data-name": "Group 116411",
    transform: "translate(0 14.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116408",
    "data-name": "Group 116408",
    transform: "translate(8.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122398",
    "data-name": "Path 122398",
    d: "M374.881,216.487l-.242-.277c.609-.532.988-.814,1-.826l.218.3S375.477,215.966,374.881,216.487Z",
    transform: "translate(-374.639 -215.385)",
    fill: "#ccc3bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116409",
    "data-name": "Group 116409",
    transform: "translate(0 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122399",
    "data-name": "Path 122399",
    d: "M354.526,274.118l-.012-.367q1.3-.044,2.536-.108l.019.367Q355.828,274.073,354.526,274.118Zm4-.192-.023-.367c.851-.054,1.7-.117,2.53-.187l.031.366C360.228,273.808,359.374,273.871,358.521,273.926Zm3.986-.321-.036-.366c.856-.084,1.7-.179,2.52-.282l.046.364C364.218,273.424,363.367,273.519,362.507,273.6Zm3.972-.476-.052-.364c.86-.123,1.7-.258,2.5-.4l.064.362C368.188,272.869,367.342,273,366.479,273.128Zm3.945-.671-.072-.36c.845-.168,1.677-.352,2.471-.547l.088.357C372.111,272.1,371.274,272.287,370.424,272.457Zm3.9-.917-.1-.354c.839-.231,1.652-.48,2.418-.74l.118.348C375.987,271.056,375.166,271.306,374.321,271.539Zm3.81-1.241-.132-.343c.812-.312,1.592-.647,2.318-1l.159.331C379.741,269.644,378.953,269.983,378.131,270.3Zm3.644-1.679-.178-.321a21.309,21.309,0,0,0,2.128-1.341l.215.3A21.571,21.571,0,0,1,381.775,268.62Zm3.317-2.268-.238-.279a14.8,14.8,0,0,0,1.764-1.777l.283.236A15.253,15.253,0,0,1,385.092,266.352Zm2.686-3-.307-.2a12.262,12.262,0,0,0,1.157-2.211l.341.135A12.6,12.6,0,0,1,387.777,263.352Zm1.656-3.674-.354-.1a13.767,13.767,0,0,0,.423-2.467l.366.03A14.093,14.093,0,0,1,389.433,259.678Zm.12-4c0-.319-.014-.65-.035-.984-.032-.519-.087-1.031-.163-1.522l.363-.056c.078.5.134,1.025.167,1.555.021.34.033.677.035,1Zm-.485-3.909a12.762,12.762,0,0,0-.851-2.351l.331-.159a13.116,13.116,0,0,1,.876,2.419Zm-1.548-3.6a11.088,11.088,0,0,0-1.58-1.929l.256-.263a11.43,11.43,0,0,1,1.633,1.993Zm-2.665-2.858a12.55,12.55,0,0,0-2.14-1.29l.158-.331a12.879,12.879,0,0,1,2.2,1.328Zm-3.463-1.84a17.148,17.148,0,0,0-2.421-.667l.072-.36a17.566,17.566,0,0,1,2.473.682Zm-17.638-.143q-.328,0-.647-.009l.01-.367a24.807,24.807,0,0,0,2.521-.064l.027.367C365.014,243.308,364.371,243.333,363.752,243.333Zm-2.109-.1a17.969,17.969,0,0,1-2.53-.424l.087-.357a17.541,17.541,0,0,0,2.478.415Zm5.475-.121-.046-.365c.426-.054.865-.118,1.305-.193q.612-.1,1.206-.186l.051.364q-.588.082-1.2.185C367.993,242.993,367.549,243.059,367.118,243.113Zm10.431-.537a24.512,24.512,0,0,0-2.514-.185l.009-.367a24.866,24.866,0,0,1,2.552.188Zm-6.48-.018-.037-.365c.869-.089,1.727-.145,2.55-.168l.01.367C372.779,242.415,371.93,242.471,371.07,242.558Zm-13.366-.167a12.32,12.32,0,0,1-2.329-1.1l.192-.313a11.973,11.973,0,0,0,2.259,1.066Zm-3.53-1.959a8.844,8.844,0,0,1-1.73-1.921l.306-.2a8.478,8.478,0,0,0,1.659,1.841Zm-2.432-3.227a8.262,8.262,0,0,1-.621-2.512l.366-.032a7.917,7.917,0,0,0,.593,2.4Zm-.261-3.964-.367-.028a10.453,10.453,0,0,1,.379-2.076c.043-.151.088-.3.135-.45l.35.111c-.046.146-.09.292-.132.44A10.043,10.043,0,0,0,351.481,233.241Zm.983-3.8-.341-.137a21.342,21.342,0,0,1,1.1-2.314l.321.177A21,21,0,0,0,352.464,229.443Zm1.82-3.513-.31-.2c.447-.7.944-1.405,1.479-2.089l.289.226C355.215,224.545,354.724,225.238,354.284,225.93Zm2.377-3.174-.278-.241c.557-.641,1.148-1.266,1.759-1.858l.256.264C357.795,221.506,357.21,222.123,356.661,222.756Z",
    transform: "translate(-351.114 -220.657)",
    fill: "#ccc3bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116410",
    "data-name": "Group 116410",
    transform: "translate(0.573 54.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122400",
    "data-name": "Path 122400",
    d: "M352.784,375.34l-.005-.367q.648-.01,1.284-.026l.009.367Q353.434,375.33,352.784,375.34Z",
    transform: "translate(-352.778 -374.947)",
    fill: "#ccc3bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116416",
    "data-name": "Group 116416",
    transform: "translate(2.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116412",
    "data-name": "Group 116412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122401",
    "data-name": "Path 122401",
    d: "M364.573,184.366l-6.986-4.573,30.13-5.9Z",
    transform: "translate(-357.587 -173.893)",
    fill: "#f2e2e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116413",
    "data-name": "Group 116413",
    transform: "translate(6.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122402",
    "data-name": "Path 122402",
    d: "M377.872,184.366l2.032,4.584,21.111-15.057Z",
    transform: "translate(-377.872 -173.893)",
    fill: "#e0d3d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116414",
    "data-name": "Group 116414",
    transform: "translate(9.019 12.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122403",
    "data-name": "Path 122403",
    d: "M384.733,209.471l-.96,2.436,4.517-3Z",
    transform: "translate(-383.773 -208.91)",
    fill: "#ccbec1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116415",
    "data-name": "Group 116415",
    transform: "translate(9.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122404",
    "data-name": "Path 122404",
    d: "M386.559,186.514l5.753,9.671,14.4-22.292Z",
    transform: "translate(-386.559 -173.893)",
    fill: "#f2e2e5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116492",
    "data-name": "Group 116492",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122405",
    "data-name": "Path 122405",
    d: "M47.26,389.566a78.082,78.082,0,0,0-9.308,2.852c-3.184,1.37-7.453,1.276,26.4,6.956s36.13,6.752,35.053,8.313,14.078,2.939,19.865,2.3,7.807-2.3,7.807-2.3,13.14,1.194,21.5,7.256c13.379-5.6,36.556-15.569,36.556-15.569l-18.467-4.546Z",
    transform: "translate(-35.846 -306.837)",
    fill: "#e8e2dd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116491",
    "data-name": "Group 116491",
    transform: "translate(8.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116476",
    "data-name": "Group 116476"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122406",
    "data-name": "Path 122406",
    d: "M335.645,387.386l-3.239-.371-1.077,1.3Z",
    transform: "translate(-238.046 -305.164)",
    fill: "#0a6c8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116475",
    "data-name": "Group 116475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116428",
    "data-name": "Group 116428",
    transform: "translate(17.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116427",
    "data-name": "Group 116427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116426",
    "data-name": "Group 116426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116425",
    "data-name": "Group 116425"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116418",
    "data-name": "Group 116418",
    transform: "translate(42.768 1.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122407",
    "data-name": "Path 122407",
    d: "M259.734,157.482l-.022,15.6s-18.35,1.409-22.33.149-2.112-6.524-2.108-9.037.065-8.636.705-10.076,3.669-.69,7.389-.227S259.734,157.482,259.734,157.482Z",
    transform: "translate(-234.832 -153.279)",
    fill: "#eee6de"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122408",
    "data-name": "Path 122408",
    d: "M235.277,164.195c0-2.513.065-8.636.705-10.076s3.669-.69,7.389-.227,16.366,3.59,16.366,3.59l0,2.613c-3.4-.826-12.241-2.524-15.2-2.893-3.72-.464-6.343-.955-6.983.485s-.859,6.954-.862,9.467c0,1.383-.567,3.6-.413,5.524C233.8,170.845,235.274,166.431,235.277,164.195Z",
    transform: "translate(-192.068 -151.928)",
    fill: "#efd5bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116421",
    "data-name": "Group 116421",
    transform: "translate(42.639 2.409)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116419",
    "data-name": "Group 116419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122409",
    "data-name": "Path 122409",
    d: "M236.431,156.352l24.171,4.41S241.206,156.493,236.431,156.352Z",
    transform: "translate(-235.751 -156.352)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122410",
    "data-name": "Path 122410",
    d: "M234.566,182.285l24.387,1.9S239.314,181.965,234.566,182.285Z",
    transform: "translate(-234.528 -173.333)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122411",
    "data-name": "Path 122411",
    d: "M234.57,179.427l24.374,2.526S239.327,179.2,234.57,179.427Z",
    transform: "translate(-234.531 -171.471)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122412",
    "data-name": "Path 122412",
    d: "M234.572,177.677l24.374,2.526S239.329,177.446,234.572,177.677Z",
    transform: "translate(-234.532 -170.323)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122413",
    "data-name": "Path 122413",
    d: "M234.6,175.384l24.357,2.767S239.361,175.2,234.6,175.384Z",
    transform: "translate(-234.551 -168.824)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122414",
    "data-name": "Path 122414",
    d: "M234.669,172.335l24.312,3.277S239.437,172.252,234.669,172.335Z",
    transform: "translate(-234.596 -166.829)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122415",
    "data-name": "Path 122415",
    d: "M234.671,170.138l24.312,3.272S239.439,170.054,234.671,170.138Z",
    transform: "translate(-234.597 -165.389)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122416",
    "data-name": "Path 122416",
    d: "M234.711,167.438,259,170.949S239.481,167.4,234.711,167.438Z",
    transform: "translate(-234.624 -163.62)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122417",
    "data-name": "Path 122417",
    d: "M234.714,164.921,259,168.432S239.484,164.884,234.714,164.921Z",
    transform: "translate(-234.626 -161.97)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122418",
    "data-name": "Path 122418",
    d: "M234.761,162.347l24.257,3.771S239.533,162.361,234.761,162.347Z",
    transform: "translate(-234.656 -160.282)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122419",
    "data-name": "Path 122419",
    d: "M234.457,159.475l24.257,3.771S239.229,159.489,234.457,159.475Z",
    transform: "translate(-234.457 -158.399)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116420",
    "data-name": "Group 116420",
    transform: "translate(0.066 9.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122420",
    "data-name": "Path 122420",
    d: "M236.594,206.286l23.523-.03S241.332,206.962,236.594,206.286Z",
    transform: "translate(-235.924 -198.77)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122421",
    "data-name": "Path 122421",
    d: "M234.843,184.521l24.195,1.633S239.611,185.393,234.843,184.521Z",
    transform: "translate(-234.776 -184.521)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122422",
    "data-name": "Path 122422",
    d: "M234.861,186.846l24.178,1.387S239.583,187.847,234.861,186.846Z",
    transform: "translate(-234.788 -186.045)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122423",
    "data-name": "Path 122423",
    d: "M234.916,189.941l24.136.866S239.646,190.842,234.916,189.941Z",
    transform: "translate(-234.824 -188.074)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122424",
    "data-name": "Path 122424",
    d: "M234.909,192.154l24.136.871S239.639,193.056,234.909,192.154Z",
    transform: "translate(-234.819 -189.525)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122425",
    "data-name": "Path 122425",
    d: "M234.936,194.882l24.113.626S239.668,195.737,234.936,194.882Z",
    transform: "translate(-234.837 -191.314)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122426",
    "data-name": "Path 122426",
    d: "M234.929,197.418l24.113.626S239.661,198.273,234.929,197.418Z",
    transform: "translate(-234.833 -192.976)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122427",
    "data-name": "Path 122427",
    d: "M234.964,200.02l24.084.359S239.7,200.823,234.964,200.02Z",
    transform: "translate(-234.856 -194.682)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122428",
    "data-name": "Path 122428",
    d: "M234.649,202.859l24.084.36S239.384,203.662,234.649,202.859Z",
    transform: "translate(-234.649 -196.543)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122429",
    "data-name": "Path 122429",
    d: "M236.03,208.462l24.2.279S240.777,209.16,236.03,208.462Z",
    transform: "translate(-235.488 -190.515)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116424",
    "data-name": "Group 116424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116422",
    "data-name": "Group 116422",
    transform: "translate(0 0.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122430",
    "data-name": "Path 122430",
    d: "M156.37,149.429s-40,4.31-43.264,5.281-2.522,10.654-1.964,13.658,2.758,3.88,5.1,3.974,43.585-.076,43.585-.076-5.562-1.019-6.151-5.246.378-12.627.567-14.054S156.37,149.429,156.37,149.429Z",
    transform: "translate(-110.652 -149.429)",
    fill: "#183240"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122431",
    "data-name": "Path 122431",
    d: "M186.564,171.072c-.548-4.124.352-12.319.527-13.711a7.506,7.506,0,0,1,1.553-2.927h0l-2.862.342a7.157,7.157,0,0,0-1.448,2.79c-.176,1.392-1.075,9.588-.527,13.712a6.218,6.218,0,0,0,2.28,4.344l3.037-.009A6.08,6.08,0,0,1,186.564,171.072Z",
    transform: "translate(-158.494 -152.685)",
    fill: "#ffd773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122432",
    "data-name": "Path 122432",
    d: "M172.643,172.307c-.548-4.019.351-12,.527-13.361a7.218,7.218,0,0,1,1.546-2.842l-2.882.35a6.835,6.835,0,0,0-1.426,2.689c-.175,1.357-1.074,9.342-.527,13.361a6.043,6.043,0,0,0,2.266,4.226l3.035-.008A5.914,5.914,0,0,1,172.643,172.307Z",
    transform: "translate(-149.367 -153.78)",
    fill: "#ffd773"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116423",
    "data-name": "Group 116423",
    transform: "translate(41.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122433",
    "data-name": "Path 122433",
    d: "M232.292,160.59c.032-.638.063-1.254.083-1.829.013-.382.023-.77.033-1.159.077-3.019.157-6.141,1.926-7.542a3.685,3.685,0,0,1,3.07-.614c3.562.647,18.607,3.856,21.852,4.55l0,2.126c-2.12-.453-18.509-3.952-22.155-4.615a1.6,1.6,0,0,0-1.393.207c-1.038.822-1.109,3.586-1.171,6.024-.01.4-.02.791-.034,1.179-.02.585-.076,1.608-.084,1.86-.018.537-.3,8.1.98,8.937,1.417.693,13.171,1.291,23.838.769l0,2.1c-4.148.2-13.7-.122-19.75-.365a15.884,15.884,0,0,1-5.063-.685C231.816,170.1,232.058,165.264,232.292,160.59Z",
    transform: "translate(-232.156 -149.357)",
    fill: "#183240"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122434",
    "data-name": "Path 122434",
    d: "M242.382,190.219s.372,5.183.331,8.514c1.987.215,4.125.3,4.125.3S245.948,190.456,242.382,190.219Z",
    transform: "translate(-197.014 -176.146)",
    fill: "#efd5bf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122435",
    "data-name": "Path 122435",
    d: "M116.526,158.514s27.061-3.158,31.492-3.575,5.934-.812,6.541-.39.343,4.339,0,4.913-3.06.547-6.04.626-32.046,1.4-32.89,1.426-.686-1.329-.387-1.874A1.832,1.832,0,0,1,116.526,158.514Z",
    transform: "translate(-113.504 -152.642)",
    fill: "#fff",
    opacity: 0.46,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116434",
    "data-name": "Group 116434",
    transform: "translate(11.49 22.556)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122436",
    "data-name": "Path 122436",
    d: "M310.843,253.554a32.844,32.844,0,0,1,1.957,9.92,26.138,26.138,0,0,0,1.485-2.469l2.41,2.159s-1.488-9.988-3.4-13.025S310.843,253.554,310.843,253.554Z",
    transform: "translate(-236.106 -237.453)",
    fill: "#ee6d4a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116433",
    "data-name": "Group 116433"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122437",
    "data-name": "Path 122437",
    d: "M100.313,258.565l7.275,4.681h60.945l6.74-4.681s-29.426-1-39.072-1.718S100.313,258.565,100.313,258.565Z",
    transform: "translate(-98.083 -242.297)",
    fill: "#183240"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116432",
    "data-name": "Group 116432"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116431",
    "data-name": "Group 116431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116430",
    "data-name": "Group 116430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116429",
    "data-name": "Group 116429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122438",
    "data-name": "Path 122438",
    d: "M96.069,214.849s72.075.3,74.707.608c1.62.506,1.518,4.656,1.62,8.2s.2,6.925-1.367,7.461-73.779.038-74.96,0-1.991-2.332-2.126-6.044S93.4,214.837,96.069,214.849Z",
    transform: "translate(-93.839 -214.849)",
    fill: "#183240"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122439",
    "data-name": "Path 122439",
    d: "M116.162,214.925l-2.617-.012a3.551,3.551,0,0,0-.592,2.171v10.309a8.773,8.773,0,0,0,1.154,3.814l3.207.022a6.919,6.919,0,0,1-1.771-3.606,80.244,80.244,0,0,1-.136-10.151A5.3,5.3,0,0,1,116.162,214.925Z",
    transform: "translate(-106.369 -214.891)",
    fill: "#4cede5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122440",
    "data-name": "Path 122440",
    d: "M129.517,214.989l-2.616-.013a3.578,3.578,0,0,0-.576,2.149v10.309a8.8,8.8,0,0,0,1.172,3.845l3.215.02a6.941,6.941,0,0,1-1.8-3.636,80.316,80.316,0,0,1-.136-10.151A5.391,5.391,0,0,1,129.517,214.989Z",
    transform: "translate(-115.137 -214.932)",
    fill: "#4cede5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122441",
    "data-name": "Path 122441",
    d: "M292.173,232.176c1.154-.008,2.219-.017,3.181-.029a8.665,8.665,0,0,0,1.1-3.72V218.12a3.8,3.8,0,0,0-.446-1.944c-.8-.012-1.683-.024-2.643-.036a5.936,5.936,0,0,1,.634,2.368,80.258,80.258,0,0,1-.136,10.151A6.845,6.845,0,0,1,292.173,232.176Z",
    transform: "translate(-223.866 -215.695)",
    fill: "#4cede5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122442",
    "data-name": "Path 122442",
    d: "M278.743,232.1c1.111,0,2.174-.008,3.18-.013a8.7,8.7,0,0,0,1.124-3.757V218.019a3.744,3.744,0,0,0-.48-2l-2.644-.029a5.723,5.723,0,0,1,.67,2.421,80.253,80.253,0,0,1-.136,10.151A6.86,6.86,0,0,1,278.743,232.1Z",
    transform: "translate(-215.061 -215.594)",
    fill: "#4cede5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122443",
    "data-name": "Path 122443",
    d: "M97.516,218.082h73.02c1.687,0,2.261.757,2.4,2.1s-.405,1.578-3.779,1.536-69.408,0-71.636,0S95.846,218.082,97.516,218.082Z",
    transform: "translate(-95.287 -216.969)",
    fill: "#00c1bc",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116447",
    "data-name": "Group 116447",
    transform: "translate(0 68.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116446",
    "data-name": "Group 116446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116439",
    "data-name": "Group 116439"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116436",
    "data-name": "Group 116436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116435",
    "data-name": "Group 116435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122444",
    "data-name": "Path 122444",
    d: "M114.193,374.794s-47.062-9.352-50.571-10.42-4.577-11.443-.61-12.739,48.822-4.043,48.822-4.043l52.216,2.995Z",
    transform: "translate(-60.478 -347.592)",
    fill: "#167ba8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122445",
    "data-name": "Path 122445",
    d: "M63.623,374.287c3.509,1.068,50.571,10.42,50.571,10.42l26.883-13.7-79.536-8.295C59.431,365.8,60.65,373.382,63.623,374.287Z",
    transform: "translate(-60.48 -357.505)",
    fill: "#3989b4"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116437",
    "data-name": "Group 116437",
    transform: "translate(49.951 4.247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122446",
    "data-name": "Path 122446",
    d: "M257.875,359.922c-9.686.8-44.259,3.813-48.974,6.433-5.492,3.051-3.661,15.1.915,15.409,3.708.247,35.945-6.613,48.059-9.229Z",
    transform: "translate(-205.514 -359.922)",
    fill: "#eee6de"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122447",
    "data-name": "Path 122447",
    d: "M211.44,370.131c4.367-2.426,34.334-5.189,46.436-6.22v-3.989c-9.686.8-44.259,3.813-48.974,6.433-4.987,2.77-3.936,12.959-.275,15.041C207.43,377.518,207.989,372.049,211.44,370.131Z",
    transform: "translate(-155.563 -355.675)",
    fill: "#efd5bf"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116438",
    "data-name": "Group 116438",
    transform: "translate(48.805 2.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122448",
    "data-name": "Path 122448",
    d: "M256.952,368.711c-14.75,3.2-44.834,9.535-49.047,9.534-.072,0-.137,0-.194-.006-1.215-.081-2.395-1.761-2.936-4.181-.761-3.4-.147-7.616,2.5-9.087,4.182-2.323,36.059-5.3,49.677-6.39v-2.3c-8.228.657-45.557,3.778-50.788,6.685-3.8,2.111-4.54,7.486-3.622,11.588.789,3.525,2.445,5.8,4.75,5.951.073,0,.423.02.516.02,4.995,0,37.627-6.98,49.144-9.478Z",
    transform: "translate(-202.186 -356.287)",
    fill: "#0a759b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122449",
    "data-name": "Path 122449",
    d: "M218.006,371.805l47.449-6.484S227.084,369.517,218.006,371.805Z",
    transform: "translate(-163.753 -359.215)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122450",
    "data-name": "Path 122450",
    d: "M216.35,375.646l47.448-6.484S225.428,373.358,216.35,375.646Z",
    transform: "translate(-162.667 -361.733)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122451",
    "data-name": "Path 122451",
    d: "M212.809,379.4l48.285-6.78S221.887,377.113,212.809,379.4Z",
    transform: "translate(-160.345 -364.001)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122452",
    "data-name": "Path 122452",
    d: "M212.646,382.821l48.265-7.266S221.724,380.533,212.646,382.821Z",
    transform: "translate(-160.239 -365.924)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122453",
    "data-name": "Path 122453",
    d: "M212.646,386.145l48.265-7.57S221.724,383.857,212.646,386.145Z",
    transform: "translate(-160.239 -367.904)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122454",
    "data-name": "Path 122454",
    d: "M212.646,389.056l48.265-7.963S221.724,386.767,212.646,389.056Z",
    transform: "translate(-160.239 -369.555)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122455",
    "data-name": "Path 122455",
    d: "M213.716,391.8l47.973-7.887S222.794,389.515,213.716,391.8Z",
    transform: "translate(-160.94 -371.406)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122456",
    "data-name": "Path 122456",
    d: "M213.716,394.777l47.9-7.981S222.794,392.489,213.716,394.777Z",
    transform: "translate(-160.94 -373.294)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122457",
    "data-name": "Path 122457",
    d: "M215.7,397.307l47.405-8.573S224.774,395.019,215.7,397.307Z",
    transform: "translate(-162.238 -374.564)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122458",
    "data-name": "Path 122458",
    d: "M218.006,400l46.878-8.853S227.084,397.707,218.006,400Z",
    transform: "translate(-163.753 -376.144)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116440",
    "data-name": "Group 116440",
    transform: "translate(0.62 5.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122459",
    "data-name": "Path 122459",
    d: "M63.334,364.64s31.868,4.691,38.5,5.664,8.239.686,8.01,3.461-1.144,2.766-10.585,1.454-34.156-6.117-35.929-6.4S62.349,364.495,63.334,364.64Z",
    transform: "translate(-62.279 -364.636)",
    fill: "#3c9cc6"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116441",
    "data-name": "Group 116441",
    transform: "translate(8.161 7.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122460",
    "data-name": "Path 122460",
    d: "M107.687,383.417a1.177,1.177,0,0,1-.183-.015c-8.523-1.382-18.779-3.544-21.72-4.174a1.508,1.508,0,0,1-1.147-1.117c-.4-1.68-1.122-5.881.884-8.6a1.363,1.363,0,0,1,1.267-.525l21.608,2.647a1.16,1.16,0,0,1,.989,1.423,28.284,28.284,0,0,0-.578,9.117,1.131,1.131,0,0,1-.356.939A1.114,1.114,0,0,1,107.687,383.417ZM86.611,369.249a1.078,1.078,0,0,0-.872.426c-1.939,2.625-1.232,6.73-.838,8.374a1.235,1.235,0,0,0,.94.914c2.939.63,13.19,2.791,21.707,4.171a.844.844,0,0,0,.718-.218.864.864,0,0,0,.271-.715,28.549,28.549,0,0,1,.585-9.207.886.886,0,0,0-.132-.711.9.9,0,0,0-.627-.378l-21.608-2.647A1.1,1.1,0,0,0,86.611,369.249Z",
    transform: "translate(-84.174 -368.978)",
    fill: "#b6e2ff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116443",
    "data-name": "Group 116443",
    transform: "translate(37.605 14.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116442",
    "data-name": "Group 116442",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1983",
    "data-name": "Ellipse 1983",
    cx: 2.517,
    cy: 3.514,
    rx: 2.517,
    ry: 3.514,
    fill: "#003e60"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122461",
    "data-name": "Path 122461",
    d: "M170.295,393.194c0-1.94,1.126-3.512,2.516-3.514a1.855,1.855,0,0,0-.628-.114c-1.39,0-2.518,1.573-2.518,3.514s1.127,3.514,2.518,3.514h0A3.5,3.5,0,0,1,170.295,393.194Z",
    transform: "translate(-169.665 -389.566)",
    fill: "#0a759b"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116445",
    "data-name": "Group 116445",
    transform: "translate(3.83 8.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116444",
    "data-name": "Group 116444"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1984",
    "data-name": "Ellipse 1984",
    cx: 1.926,
    cy: 2.688,
    rx: 1.926,
    ry: 2.688,
    fill: "#003e60"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122462",
    "data-name": "Path 122462",
    d: "M72.08,376.211c0-1.484.862-2.687,1.925-2.688a1.419,1.419,0,0,0-.48-.087c-1.064,0-1.926,1.2-1.926,2.688s.862,2.688,1.926,2.688h0A2.679,2.679,0,0,1,72.08,376.211Z",
    transform: "translate(-71.599 -373.435)",
    fill: "#0a759b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122463",
    "data-name": "Path 122463",
    d: "M219.367,399.114s.409,5.816.37,9.458c1.061-.081,4.328-.559,4.328-.559S223.206,399.217,219.367,399.114Z",
    transform: "translate(-164.645 -381.37)",
    fill: "#efd5bf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122464",
    "data-name": "Path 122464",
    d: "M219.367,396.928s3.913,2.485,4.143,14.2c1.831-1.9,3.089-3.11,3.089-3.11l3.307,1.933s-2.175-12.4-4.738-14.136A29.8,29.8,0,0,0,219.367,396.928Z",
    transform: "translate(-164.645 -379.206)",
    fill: "#ee6d4a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116462",
    "data-name": "Group 116462",
    transform: "translate(5.46 56.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116461",
    "data-name": "Group 116461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116460",
    "data-name": "Group 116460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116456",
    "data-name": "Group 116456"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116451",
    "data-name": "Group 116451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116449",
    "data-name": "Group 116449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116448",
    "data-name": "Group 116448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122465",
    "data-name": "Path 122465",
    d: "M118.9,334.479s41.09-4.98,44.119-6.079,3.951-10.109.527-11.028-42.144-2.938-42.144-2.938l-45.074,1.544Z",
    transform: "translate(-76.332 -314.434)",
    fill: "#e0512f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116450",
    "data-name": "Group 116450",
    transform: "translate(22.585 3.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122466",
    "data-name": "Path 122466",
    d: "M206.016,335.765c-3.029,1.1-44.119,6.079-44.119,6.079L141.909,330.06l20.077-3.919,45.827-.473C209.635,328.223,208.582,334.833,206.016,335.765Z",
    transform: "translate(-141.909 -325.668)",
    fill: "#ee6d4a"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116452",
    "data-name": "Group 116452",
    transform: "translate(1.087 2.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122467",
    "data-name": "Path 122467",
    d: "M79.487,321.87c8.361.2,38.205,1.059,42.276,3.082,4.741,2.357,3.161,12.854-.79,13.348-3.2.4-31.029-3.9-41.486-5.541Z",
    transform: "translate(-79.487 -321.87)",
    fill: "#eee6de"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122468",
    "data-name": "Path 122468",
    d: "M119.571,328.34c-3.77-1.874-29.638-2.747-40.084-3.026V321.87c8.361.2,38.205,1.059,42.276,3.082,4.3,2.14,3.4,10.989.237,12.97C123.033,334.515,122.55,329.821,119.571,328.34Z",
    transform: "translate(-78.4 -319.309)",
    fill: "#efd5bf"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116454",
    "data-name": "Group 116454",
    transform: "translate(0 1.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116453",
    "data-name": "Group 116453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122469",
    "data-name": "Path 122469",
    d: "M76.332,329.641c12.733,2.018,38.7,5.969,42.339,5.756.062,0,.118-.009.168-.014,1.048-.132,2.067-1.641,2.534-3.757.657-2.975.127-6.582-2.158-7.718-3.61-1.795-31.127-2.754-42.883-3.009v-1.982c7.1.152,39.326.963,43.842,3.208,3.279,1.63,3.919,6.233,3.127,9.82-.681,3.082-2.341,5.152-4.331,5.4-.063.008-.135.014-.215.019-4.311.251-32.481-4.127-42.423-5.7Z",
    transform: "translate(-76.332 -318.916)",
    fill: "#f48369"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116455",
    "data-name": "Group 116455",
    transform: "translate(1.613 4.135)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122470",
    "data-name": "Path 122470",
    d: "M121.975,329.644l-40.959-3.2S114.139,328.127,121.975,329.644Z",
    transform: "translate(-81.016 -326.441)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122471",
    "data-name": "Path 122471",
    d: "M123.4,332.876l-40.959-3.2S115.569,331.359,123.4,332.876Z",
    transform: "translate(-81.953 -328.56)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122472",
    "data-name": "Path 122472",
    d: "M125.088,336.019,83.407,332.6S117.251,334.5,125.088,336.019Z",
    transform: "translate(-82.584 -330.48)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122473",
    "data-name": "Path 122473",
    d: "M125.261,338.962,83.6,335.125S117.425,337.445,125.261,338.962Z",
    transform: "translate(-82.709 -332.134)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122474",
    "data-name": "Path 122474",
    d: "M125.261,341.832l-41.663-4.1S117.425,340.314,125.261,341.832Z",
    transform: "translate(-82.709 -333.843)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122475",
    "data-name": "Path 122475",
    d: "M125.261,344.343,83.6,339.9S117.425,342.826,125.261,344.343Z",
    transform: "translate(-82.709 -335.268)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122476",
    "data-name": "Path 122476",
    d: "M124.818,346.741l-41.411-4.387S116.982,345.224,124.818,346.741Z",
    transform: "translate(-82.584 -336.873)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122477",
    "data-name": "Path 122477",
    d: "M124.943,349.3,83.6,344.828S117.107,347.783,124.943,349.3Z",
    transform: "translate(-82.709 -338.495)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122478",
    "data-name": "Path 122478",
    d: "M124.041,351.538,83.12,346.529S116.2,350.02,124.041,351.538Z",
    transform: "translate(-82.395 -339.611)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122479",
    "data-name": "Path 122479",
    d: "M122.913,353.924l-40.467-5.276S115.076,352.407,122.913,353.924Z",
    transform: "translate(-81.953 -341)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116457",
    "data-name": "Group 116457",
    transform: "translate(48.166 4.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122480",
    "data-name": "Path 122480",
    d: "M256.023,328.388s-25.8,2.007-32.555,2.68c-5.819.58-7.466.179-7.268,2.563s3.526,1.882,11.785,1c9.173-.98,26.462-2.637,27.993-2.974S256.873,328.213,256.023,328.388Z",
    transform: "translate(-216.184 -328.38)",
    fill: "#f48369"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116458",
    "data-name": "Group 116458",
    transform: "translate(83.852 4.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122481",
    "data-name": "Path 122481",
    d: "M319.937,336.762a.147.147,0,0,1-.131-.107.127.127,0,0,1,.094-.162,3.58,3.58,0,0,0,2.077-1.985,45.955,45.955,0,0,0,.656-5.293,2.729,2.729,0,0,0-1.187-2.62.143.143,0,0,1-.061-.186.129.129,0,0,1,.181-.049,3.068,3.068,0,0,1,1.337,2.892,46.128,46.128,0,0,1-.663,5.332,3.817,3.817,0,0,1-2.268,2.175A.124.124,0,0,1,319.937,336.762Z",
    transform: "translate(-319.801 -326.341)",
    fill: "#f9a0a0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116459",
    "data-name": "Group 116459",
    transform: "translate(82.083 4.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122482",
    "data-name": "Path 122482",
    d: "M314.8,337.3a.148.148,0,0,1-.131-.108.127.127,0,0,1,.094-.161,3.58,3.58,0,0,0,2.077-1.985,45.968,45.968,0,0,0,.656-5.293,2.728,2.728,0,0,0-1.187-2.62.143.143,0,0,1-.061-.186.128.128,0,0,1,.181-.049,3.067,3.067,0,0,1,1.337,2.892,46.127,46.127,0,0,1-.662,5.332,3.819,3.819,0,0,1-2.268,2.175A.137.137,0,0,1,314.8,337.3Z",
    transform: "translate(-314.664 -326.882)",
    fill: "#f9a0a0"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122483",
    "data-name": "Path 122483",
    d: "M229.563,336.015a17.472,17.472,0,0,1-1.7,8.783l3.471-.437a22.44,22.44,0,0,0,1.427-7.833,7.683,7.683,0,0,0-1.245-4.542l-3.22.215A7.748,7.748,0,0,1,229.563,336.015Z",
    transform: "translate(-175.676 -325.941)",
    fill: "#cc3a1d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122484",
    "data-name": "Path 122484",
    d: "M244.533,335.039a17.345,17.345,0,0,1-1.561,8.46l3.461-.442a23.113,23.113,0,0,0,1.3-7.5,7.681,7.681,0,0,0-1.248-4.546l-3.22.215A7.75,7.75,0,0,1,244.533,335.039Z",
    transform: "translate(-185.58 -325.299)",
    fill: "#cc3a1d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122485",
    "data-name": "Path 122485",
    d: "M186.692,344.828s-.38,6.084-.343,9.478c-.989-.075-4.141-.374-4.141-.374S183.114,344.924,186.692,344.828Z",
    transform: "translate(-145.744 -334.36)",
    fill: "#efd5bf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122486",
    "data-name": "Path 122486",
    d: "M176.526,343.643s-3.648,2.731-3.861,13.651c-1.707-1.774-2.88-2.9-2.88-2.9l-3.083,1.8s2.027-11.556,4.416-13.177C174.626,343.407,176.526,343.643,176.526,343.643Z",
    transform: "translate(-135.578 -333.175)",
    fill: "#ffbc00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116471",
    "data-name": "Group 116471",
    transform: "translate(17.911 35.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116470",
    "data-name": "Group 116470"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116463",
    "data-name": "Group 116463",
    transform: "translate(1.261 1.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122487",
    "data-name": "Path 122487",
    d: "M116.144,260.7v15.649s18.127,2.153,22.06,1.05,2.1-6.459,2.1-8.98-.052-8.665-.683-10.135-3.623-.84-7.3-.525S116.144,260.7,116.144,260.7Z",
    transform: "translate(-116.144 -257.347)",
    fill: "#eee6de"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122488",
    "data-name": "Path 122488",
    d: "M140.3,268.415c0-2.521-.052-8.665-.683-10.135s-3.623-.84-7.3-.525-16.174,2.941-16.174,2.941v2.621c3.363-.691,12.1-2.039,15.019-2.289,3.676-.315,6.268-.7,6.9.768s.839,7.009.839,9.53c0,1.388.555,3.633.4,5.557C141.752,275.145,140.3,270.658,140.3,268.415Z",
    transform: "translate(-114.883 -255.987)",
    fill: "#efd5bf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116466",
    "data-name": "Group 116466",
    transform: "translate(1.326 2.535)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116464",
    "data-name": "Group 116464",
    transform: "translate(0.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122489",
    "data-name": "Path 122489",
    d: "M140.541,260.76l-23.886,3.449S135.823,260.709,140.541,260.76Z",
    transform: "translate(-116.655 -260.759)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122490",
    "data-name": "Path 122490",
    d: "M141.946,286.7l-24.1.923S137.256,286.186,141.946,286.7Z",
    transform: "translate(-117.438 -277.692)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122491",
    "data-name": "Path 122491",
    d: "M141.97,283.894l-24.084,1.551S137.271,283.47,141.97,283.894Z",
    transform: "translate(-117.462 -275.887)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122492",
    "data-name": "Path 122492",
    d: "M141.97,282.139l-24.084,1.551S137.271,281.715,141.97,282.139Z",
    transform: "translate(-117.462 -274.736)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122493",
    "data-name": "Path 122493",
    d: "M141.978,279.857l-24.067,1.793S137.275,279.481,141.978,279.857Z",
    transform: "translate(-117.478 -273.251)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122494",
    "data-name": "Path 122494",
    d: "M142,276.828l-24.023,2.307S137.287,276.552,142,276.828Z",
    transform: "translate(-117.52 -271.28)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122495",
    "data-name": "Path 122495",
    d: "M142,274.623l-24.023,2.3S137.288,274.347,142,274.623Z",
    transform: "translate(-117.52 -269.835)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122496",
    "data-name": "Path 122496",
    d: "M142.008,271.925l-24,2.542S137.3,271.7,142.008,271.925Z",
    transform: "translate(-117.543 -268.071)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122497",
    "data-name": "Path 122497",
    d: "M142.008,269.4l-24,2.542S137.3,269.171,142.008,269.4Z",
    transform: "translate(-117.543 -266.415)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122498",
    "data-name": "Path 122498",
    d: "M142.021,266.826l-23.97,2.8S137.306,266.648,142.021,266.826Z",
    transform: "translate(-117.57 -264.732)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122499",
    "data-name": "Path 122499",
    d: "M142.326,263.958l-23.97,2.8S137.611,263.78,142.326,263.958Z",
    transform: "translate(-117.77 -262.852)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116465",
    "data-name": "Group 116465",
    transform: "translate(0.205 9.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122500",
    "data-name": "Path 122500",
    d: "M140.641,308.484l-23.712-1.267S135.958,308.971,140.641,308.484Z",
    transform: "translate(-116.929 -300.97)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122501",
    "data-name": "Path 122501",
    d: "M142.033,289.079l-23.9.663S137.321,289.761,142.033,289.079Z",
    transform: "translate(-117.715 -289.079)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122502",
    "data-name": "Path 122502",
    d: "M142.043,291.41l-23.888.417S137.376,292.224,142.043,291.41Z",
    transform: "translate(-117.733 -290.607)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122503",
    "data-name": "Path 122503",
    d: "M142.066,294.314l-23.846-.1S137.392,295.027,142.066,294.314Z",
    transform: "translate(-117.775 -292.442)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122504",
    "data-name": "Path 122504",
    d: "M142.069,296.543l-23.846-.1S137.4,297.257,142.069,296.543Z",
    transform: "translate(-117.777 -293.907)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122505",
    "data-name": "Path 122505",
    d: "M142.084,298.814l-23.823-.344S137.407,299.48,142.084,298.814Z",
    transform: "translate(-117.802 -295.236)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122506",
    "data-name": "Path 122506",
    d: "M142.087,301.358l-23.823-.344S137.41,302.024,142.087,301.358Z",
    transform: "translate(-117.804 -296.904)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122507",
    "data-name": "Path 122507",
    d: "M142.1,303.458l-23.794-.61S137.424,304.073,142.1,303.458Z",
    transform: "translate(-117.834 -298.106)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122508",
    "data-name": "Path 122508",
    d: "M142.41,306.319l-23.794-.61S137.731,306.934,142.41,306.319Z",
    transform: "translate(-118.035 -299.982)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122509",
    "data-name": "Path 122509",
    d: "M140.441,310.922l-24.108-1.115S135.75,311.431,140.441,310.922Z",
    transform: "translate(-116.333 -292.915)",
    fill: "#e8d3c1",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116469",
    "data-name": "Group 116469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116467",
    "data-name": "Group 116467",
    transform: "translate(21.983 0.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122510",
    "data-name": "Path 122510",
    d: "M177.286,253.536s39.514,5.936,42.735,7.041,2.8,9.387,2.24,12.378-2.73,3.781-5.041,3.781-40.907-.492-40.907-.492,3.024-.738,3.612-4.954-.356-12.68-.54-14.119S177.286,253.536,177.286,253.536Z",
    transform: "translate(-176.313 -253.536)",
    fill: "#ffbc00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122511",
    "data-name": "Path 122511",
    d: "M223.092,263.238c.172,1.338,1.049,9.207.5,13.127-.47,3.369-2.609,4.347-3.2,4.556l3.306.041a5.463,5.463,0,0,0,2.624-4.289c.547-3.919-.331-11.789-.5-13.127a7.092,7.092,0,0,0-1.427-2.725l-2.832-.443A7.454,7.454,0,0,1,223.092,263.238Z",
    transform: "translate(-183.229 -257.975)",
    fill: "#ffd773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122512",
    "data-name": "Path 122512",
    d: "M237.524,265.316c.172,1.3,1.049,8.972.5,12.792a5.245,5.245,0,0,1-2.845,4.292l3.2.039a5.415,5.415,0,0,0,2.371-4.031c.547-3.819-.33-11.488-.5-12.792a6.782,6.782,0,0,0-1.405-2.628L236,262.537A7.176,7.176,0,0,1,237.524,265.316Z",
    transform: "translate(-192.924 -259.39)",
    fill: "#ffd773"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116468",
    "data-name": "Group 116468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122513",
    "data-name": "Path 122513",
    d: "M139.114,264.839c-.031-.641-.06-1.261-.08-1.838-.013-.384-.022-.774-.031-1.164-.072-3.032-.147-6.167-1.892-7.643a3.686,3.686,0,0,0-3.032-.74c-3.52.506-18.388,3.118-21.6,3.683v2.133c2.1-.369,18.292-3.218,21.895-3.736a1.6,1.6,0,0,1,1.376.264c1.024.866,1.09,3.641,1.148,6.089.01.4.019.794.032,1.184.02.588.073,1.616.081,1.869.017.539.281,8.134-.981,8.924-1.4.638-13.013.039-23.551-.915v2.109c4.1.369,13.535,1.155,19.511,1.155a15.232,15.232,0,0,0,5-.483C139.571,274.395,139.339,269.537,139.114,264.839Z",
    transform: "translate(-112.484 -253.4)",
    fill: "#f7a500"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122514",
    "data-name": "Path 122514",
    d: "M171.677,294.491s-.375,5.184-.339,8.526c-1.963.136-4.076.136-4.076.136S168.153,294.585,171.677,294.491Z",
    transform: "translate(-148.396 -280.339)",
    fill: "#efd5bf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122515",
    "data-name": "Path 122515",
    d: "M161.244,294.325s-3.822,3.145-4.031,13.942c-1.678-1.493-2.832-2.427-2.832-2.427l-3.032,2.238s2.137-11.821,4.487-13.776A47.516,47.516,0,0,1,161.244,294.325Z",
    transform: "translate(-137.964 -280.177)",
    fill: "#3989b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116472",
    "data-name": "Group 116472",
    transform: "translate(44.483 37.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122516",
    "data-name": "Path 122516",
    d: "M190.091,258.66s35.813,5.622,37.106,5.854,1.518,1.523,1.788,2.5-.776.574-2.936.371-32.056-4-33.675-4.228-1.856-.821-2.126-1.7a12.605,12.605,0,0,1-.608-2.47C189.691,258.716,189.816,258.617,190.091,258.66Z",
    transform: "translate(-189.636 -258.651)",
    fill: "#fff",
    opacity: 0.37,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116473",
    "data-name": "Group 116473",
    transform: "translate(47.055 37.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122517",
    "data-name": "Path 122517",
    d: "M197.29,278.836a.184.184,0,0,1-.1-.336,7.82,7.82,0,0,0,1.618-4.4c.091-2.119.091-6.926,0-10.943-.089-3.9-1.361-5.33-1.375-5.345a.184.184,0,0,1,.269-.25c.056.06,1.381,1.522,1.473,5.586.092,4.024.091,8.841,0,10.967a8.063,8.063,0,0,1-1.781,4.694A.185.185,0,0,1,197.29,278.836Z",
    transform: "translate(-197.106 -257.5)",
    fill: "#cc8200"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116474",
    "data-name": "Group 116474",
    transform: "translate(49.095 37.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122518",
    "data-name": "Path 122518",
    d: "M203.212,279.441a.184.184,0,0,1-.1-.337,7.823,7.823,0,0,0,1.618-4.4c.091-2.119.091-6.926,0-10.943-.089-3.9-1.362-5.33-1.375-5.344a.184.184,0,0,1,.269-.25c.056.06,1.381,1.522,1.473,5.586.091,4.024.091,8.841,0,10.967a8.063,8.063,0,0,1-1.781,4.694A.185.185,0,0,1,203.212,279.441Z",
    transform: "translate(-203.028 -258.106)",
    fill: "#cc8200"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122519",
    "data-name": "Path 122519",
    d: "M242.382,190.185s3.864,3.291,4.06,14.063c1.7-1.42,2.87-2.3,2.87-2.3l3.066,2.354s-2.146-11.872-4.521-13.916A48.893,48.893,0,0,0,242.382,190.185Z",
    transform: "translate(-179.733 -176.115)",
    fill: "#ffbc00"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116490",
    "data-name": "Group 116490",
    transform: "translate(52.666 49.004)"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116480",
    "data-name": "Group 116480",
    transform: "translate(0 8.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116479",
    "data-name": "Group 116479",
    transform: "translate(0 1.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116477",
    "data-name": "Group 116477",
    transform: "translate(0 2.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122520",
    "data-name": "Path 122520",
    d: "M213.4,336.857s9.834,6.416,15.305,23.542c-1.207,2.788.536,6.373,4.366,4.9,2.652-.663,17.363-4.57,27.577,8.688,15.124-6.089,32.377-11.818,32.377-11.818a9.805,9.805,0,0,0,.53-1.845c-.468-.333-2.5.888-3.529.425-5.876-2.653-19.029-7.94-27.078-6.167-3.143.666-4.812.185-4.812-1.538s-5.338-16.266-9.428-20.019c-10.123.1-26.117,3.2-32.407,3.3-.223,0-1.7-1.442-2.109-1.376C213.918,334.988,213.4,336.857,213.4,336.857Z",
    transform: "translate(-213.396 -331.455)",
    fill: "#87510a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122521",
    "data-name": "Path 122521",
    d: "M215.7,331.957s10.721,7.663,16.192,24.79c-1.207,2.788-.018,5.285,3.812,3.812,2.652-.663,17.207-3.429,27.21,8.726,15.124-6.089,32.149-11.949,32.149-11.949s-18.568-9.648-29.174-7.312c-3.143.667-4.812.185-4.812-1.538s-5.337-16.266-9.428-20.019C238.975,328.593,215.7,331.957,215.7,331.957Z",
    transform: "translate(-214.904 -328.467)",
    fill: "#6d3e06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_116478",
    "data-name": "Group 116478",
    transform: "translate(6.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122522",
    "data-name": "Path 122522",
    d: "M261.952,320.9l-30.984,2.061c-1.193,3.772,12.445,22.116,12.445,22.116a40.987,40.987,0,0,0,2.578,6.211l26.862-7.775C269.982,331.391,261.952,320.9,261.952,320.9Z",
    transform: "translate(-230.894 -320.898)",
    fill: "#eadbce"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122523",
    "data-name": "Path 122523",
    d: "M301.613,385.9c-.006-.028-.014-.054-.02-.082l-26.862,7.775c.048.1.094.19.143.289,14.512-2.709,27.769,7.236,27.769,7.236s6.663-2.143,32.013-11.823C328.166,386.1,307.1,384.58,301.613,385.9Z",
    transform: "translate(-253.607 -363.2)",
    fill: "#e5d1c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122524",
    "data-name": "Path 122524",
    d: "M267.643,360.525l-.013,0a34.337,34.337,0,0,0-27.748-5.6c-1.929-8.266-10.565-25.664-15.8-28.045-1.654,1.317-3.691,2.783-3.691,2.783s11.834,11,15.325,25.834c2.633-.112,3.919,2.781,3.919,2.781s8.925-1.882,15.859.276a24.947,24.947,0,0,1,11.3,8.037l.09-.032,31.782-11.449.367-4.2Z",
    transform: "translate(-217.983 -324.82)",
    fill: "#d6b8a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122525",
    "data-name": "Path 122525",
    d: "M267.63,360.529a34.337,34.337,0,0,0-27.748-5.6c-1.929-8.266-10.565-25.664-15.8-28.045-1.654,1.317-3.691,2.783-3.691,2.783s11.834,11,15.325,25.834c2.633-.112,3.919,2.781,3.919,2.781s8.925-1.882,15.859.276a24.947,24.947,0,0,1,11.3,8.037l.09-.032.76-6.034Z",
    transform: "translate(-217.983 -324.82)",
    fill: "#dbc2ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122526",
    "data-name": "Path 122526",
    d: "M276.979,392.222s11.894-4.99,27.762,2.657c16.877-4.685,30.1-8.868,30.1-8.868s-17.865-4.851-31.757-1.482S278.357,391.3,276.979,392.222Z",
    transform: "translate(-255.081 -360.308)",
    fill: "#eadbce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122527",
    "data-name": "Path 122527",
    d: "M255.673,348.1a45.883,45.883,0,0,0-11.193-30.3c7.886-.924,30.481-1.327,30.481-1.327s7.394,13.321,6.82,24.221C269.549,343.8,255.673,348.1,255.673,348.1Z",
    transform: "translate(-233.775 -316.468)",
    fill: "#eee6de"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122528",
    "data-name": "Path 122528",
    d: "M294.984,385.422S273.758,391.1,269.2,392.83s-4.25,12.569-4.25,12.569l-1.96-2.817-1.837,1.731s.788-9,5.17-12.1S290.91,385.407,294.984,385.422Z",
    transform: "translate(-244.707 -353.124)",
    fill: "#ffbc00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_122529",
    "data-name": "Path 122529",
    d: "M300.794,345.284a49.52,49.52,0,0,0-8.188.642,22.146,22.146,0,0,0-.8-7.363c-1.794-6.607-5.853-11.256-9.065-10.383s-4.362,6.935-2.568,13.542c1.242,4.572,3.568,8.205,5.948,9.721,2.363,1.63,8.038,2.779,14.668,2.779,8.75,0,15.844-2,15.844-4.469S309.545,345.284,300.794,345.284Z",
    transform: "translate(-256.623 -315.528)",
    fill: "#eee6de",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_116489",
    "data-name": "Group 116489",
    transform: "translate(26.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116488",
    "data-name": "Group 116488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116487",
    "data-name": "Group 116487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116486",
    "data-name": "Group 116486"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116481",
    "data-name": "Group 116481"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122530",
    "data-name": "Path 122530",
    d: "M324.1,299.171a18.341,18.341,0,1,1-25.628-4A18.341,18.341,0,0,1,324.1,299.171Z",
    transform: "translate(-290.944 -291.642)",
    fill: "#003e60"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116482",
    "data-name": "Group 116482",
    transform: "translate(20.442 28.917)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_122531",
    "data-name": "Path 122531",
    d: "M350.363,375.7a.488.488,0,0,0-.047-.092l-.018-.006Z",
    transform: "translate(-350.298 -375.604)",
    fill: "#c4c4c3"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116483",
    "data-name": "Group 116483",
    transform: "translate(0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122532",
    "data-name": "Path 122532",
    d: "M298.882,301.466c.148-.132.3-.153.455-.272a4.379,4.379,0,0,0,.761-.966c.153-.2.614-.836.909-.648-.012.094-.156.351-.069.442.108.112.3-.074.394-.09a2.1,2.1,0,0,0,.029.623c.292.038.293-.3.322-.5a1.579,1.579,0,0,1,.2-.629,1.828,1.828,0,0,0,.25-.478,2.425,2.425,0,0,1,.152-.588,6.909,6.909,0,0,1,.743-.934c.135-.164.321-.281.462-.434.158-.173.277-.369.429-.543.221-.253.651-.791,1.041-.735-.141.238-.5.38-.624.628-.085.169-.008.2-.177.324-.13.1-.356.157-.324.366.1,0,.193-.019.24.065.189-.013.337-.281.474-.127.172.193-.164.349-.131.5.045.208.345-.17.387-.261a2.983,2.983,0,0,1,.2-.543,5.433,5.433,0,0,1,.55-.495,1.447,1.447,0,0,1,.472-.331,6.479,6.479,0,0,0,.647-.309c.131-.079.273-.251.435-.23,0,0,.021.039.023.043.1-.078.23-.152.328-.22s.206-.189.286-.239a8.938,8.938,0,0,1,.973-.434c.187-.082.282-.266.462-.29.078-.01.109.035.216-.01.09-.038.151-.132.218-.174.139-.089,1.031-.218.913-.424-.1-.177-1.067,0-1.25.006a8.337,8.337,0,0,0-.965.11,18.436,18.436,0,0,0-7.552,4.586,24.375,24.375,0,0,0-1.814,2.188c-.154.209-.316.41-.47.613q-.273.412-.521.837a2.315,2.315,0,0,0-.167.529c.23-.206.486-.393.723-.59C298.645,301.73,298.752,301.582,298.882,301.466Z",
    transform: "translate(-295.433 -292.848)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122533",
    "data-name": "Path 122533",
    d: "M323.9,303c-.221-.068-.28.13-.446.186,0-.039-.007-.082-.01-.121a2.644,2.644,0,0,0-.318.021.989.989,0,0,1,0-.216c.015-.014.066-.03.087-.045.005-.033-.034-.053-.023-.085.1-.079.076-.113.087-.229-.016-.016-.05-.052-.065-.066-.084.028-.281.107-.313.125-.071.04-.213-.037-.207.144a1.85,1.85,0,0,0-.453.148c-.158.27.246.16.125.387a.5.5,0,0,0-.45-.045,1,1,0,0,1-.321.088c.071.251.015.22-.095.394-.029.046-.12.036-.164.1s.033.185-.013.248c-.154.211-.753.243-.541.621.184-.167.387.083.547-.13.117.067.512-.271.6-.379.1-.135.081-.25.219-.335.041-.025.247,0,.322-.025-.06.253-.5.445-.527.676-.035.28.165.132.271.067.055-.033.085-.4.233-.1.192-.068.49-.213.547-.418a.289.289,0,0,0,.289.123c.046-.182.269-.208.238-.447a.769.769,0,0,1,.126.065.237.237,0,0,0-.029-.324C323.832,303.379,323.878,303.172,323.9,303Z",
    transform: "translate(-310.481 -298.724)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122534",
    "data-name": "Path 122534",
    d: "M350.051,375.26a.5.5,0,0,0-.047-.092l-.018-.006Z",
    transform: "translate(-329.653 -346.398)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122535",
    "data-name": "Path 122535",
    d: "M340.832,303.769A18.361,18.361,0,0,0,323.4,291.645a.777.777,0,0,0-.336.29c-.1.183-.09.112.008.253s.554.116.631.219c.276.366-.388.231-.288.5-.114.049-.569-.064-.269.246-.023.012-.062.014-.081.028.042.324.3.217.55.255.311.046.474.25.159.457.113.155.161.421-.088.452-.1-.3-.189.036-.291.013-.118-.027-.22-.112-.086-.271a.89.89,0,0,1-.449-.064c.034-.018.1-.074.133-.09-.1-.011-.325.069-.4,0-.13-.121.029-.208.136-.23a1.231,1.231,0,0,1-.393-.105c.1-.1.249-.138.335-.262-.111-.133-.425-.094-.582-.105a3.122,3.122,0,0,0-.628-.09,1.563,1.563,0,0,0-1.14.555c-.289.393-.706.385-1.109.659-.267.181-.723.595-.678.933.022.033.054-.018.062-.017-.1.389.5.161.326-.168.07.032.118,0,.193.063.074-.094.381-.663.46-.2.174-.013.189-.184.381-.153a5.6,5.6,0,0,0-.022.8c.286.074.706-.289.585-.573.343-.08.057-.414.152-.634a1.554,1.554,0,0,1,.234-.286c.1-.084.12-.2.322-.158.032.217-.189.322-.152.543.363.035.325.252.713.078.23-.1.473-.231.458.181.219.079.472-.032.683.038.087.029.106.129.169.158.041.019.266.061.278.076.479.562-.652.279-.7.318-.117-.235-.571-.053-.66.126-.129.258.207.366-.2.375-.12,0-.157-.08-.324-.017-.11.041-.165.154-.286.2a3.883,3.883,0,0,1-.391.065,4.079,4.079,0,0,1-.39.156c-.213,0-.376-.233-.652-.156-.2.056-.177.145-.327.253-.128.094-.271.041-.382.112-.262.166-.135.477-.292.686-.067.089-.2.088-.278.178s-.069.232-.16.33a1.109,1.109,0,0,1-.378-.056c-.166.231-.611-.072-.751.283a1,1,0,0,1,.123.012c-.048.05-.059.139-.091.183.565-.02.271.622-.036.791-.111-.118-.367.086-.521.124-.061.016-.08.1-.129.1-.066.006-.082-.076-.131-.07-.158.02-.269.07-.379-.037a1.172,1.172,0,0,0-.273.43,1.848,1.848,0,0,0-.137.579c-.046.326-.585,1.034.13.912a2.992,2.992,0,0,0,.494-.259c.066-.031.076-.127.13-.152s.142.022.2,0a1.047,1.047,0,0,0,.326-.164c.132-.124.221-.266.349-.4a1.336,1.336,0,0,0,.307-.476c.689.031.153-.484.588-.65.225-.086.346.127.572-.014.1-.065.075-.2.161-.263s.17-.022.263-.063c.222-.1.23-.168.495-.091.068.02.12.1.2.13s.176-.005.269.024c.192.062.843.576.9.046-.27-.014-.817-.107-.707-.488.629-.267.986.206,1.428.483a1.337,1.337,0,0,1,.529.481c.115.252-.014.583.411.492a1.645,1.645,0,0,0,.057-.217c0-.019-.04-.047-.047-.064.27-.124.013-.183,0-.3-.009-.069-.112-.03-.076-.173.014-.058.207-.048.231-.127.059-.195-.267-.2.04-.327.171-.071.39-.016.3.195a.218.218,0,0,1,.13.264c.04,0,.082.008.121.01.05.209-.08.584.162.685a.953.953,0,0,0,.011.152c.287.041.454-.109.712-.191a1.857,1.857,0,0,1,.684-.162c.142.029.107.168.261.157.1-.007.2-.192.284-.231.405-.2.212.087.355.337a.593.593,0,0,1-.133-.032c.1.082.219.147.305.218a3.718,3.718,0,0,1-.49-.026c.12.031.447.12.433.353a1.5,1.5,0,0,0,.191,0c0,.032,0,.063-.006.094a.831.831,0,0,0-.064.1c-.049,0-.105.011-.153.01,0,.145-.1.2-.227.186-.016-.027-.029-.06-.045-.088-.152.106-.869.419-.91.163-.105-.006-.148-.056-.248-.01a.308.308,0,0,0-.3-.187c-.093.124-.022.27-.086.365-.081.121-.23.127-.3.276a.213.213,0,0,1-.012.3c-.247-.012-.169-.253-.325-.348-.066-.04-.149.021-.221-.007a2.3,2.3,0,0,0-.318-.139c-.642-.088-.024.667-.488.721-.064-.053-1.2.517-1.087.077-.344-.04-.032-.2-.117-.334-.108-.167-.314-.072-.464-.064-.188.01-1.007.042-.721-.418-.04-.01-.079-.034-.121-.045.058-.263-.064-.345-.173-.543-.18-.083-.26.072-.419.125a2.077,2.077,0,0,1-.528.041c-.222,0-.777-.037-.91.247a1.583,1.583,0,0,0-.875.461c-.221.164-.185.178-.429.105-.151-.045-.36-.27-.455-.012-.191-.039-.241.067-.353.168a3.147,3.147,0,0,0-.318.3c-.137.22-.153.691-.426.811.02.179-.206.357-.3.482a1.069,1.069,0,0,1-.515.4c.015.172-.264.427-.394.54.041.01.079.038.123.047-.045.253-.423.477-.512.739.054-.011.131.018.186.01-.021.189.129.338.032.511-.242-.015-.3.231-.51.271.04.107-.024.1.088.164a1.151,1.151,0,0,0-.161.581c.048.27.181.258.076.554-.138.387-.447.639-.458,1.036.039,0,.081.009.12.01a.4.4,0,0,1,.108.315c.045-.005.108.017.152.011a.369.369,0,0,1-.023.378.44.44,0,0,0,.159.231c.014-.035.052-.085.071-.121.326-.048.429.47.588.678a3.1,3.1,0,0,1,.253.393c.074.128.1.318.162.423.093.154.238.165.354.291.157.171.079.313.364.36.261.043.764-.09.754-.418.194-.051.246.121.388.125s.2-.063.358-.064c.225,0,.516.252.59-.191.2,0,.285-.177.419-.29.154-.129.384-.136.513-.245.222-.186.261-.9.588-.475.012.029,0,.056.01.087.336-.041.471.417.573.631.039.082.081.436.1.451.174.11.394-.086.4-.258.143-.039.188.085.314.054.1-.026.158-.155.3-.189a.734.734,0,0,1,.365.025c.21.094.075.076.187.235a1.287,1.287,0,0,1,.3.619c.026.291-.183.533-.2.815a.614.614,0,0,0,.3.545c.175.15.251.284.446.44.225.179,1.312.284.884.667.451.019.1.3.215.507a.388.388,0,0,0,.028.045c-.115.211-.132.488.2.538a2.559,2.559,0,0,0,.007.354c0,.051-.111.088-.1.127.017.076.156.13.159.174a.778.778,0,0,1-.23.569c-.172.227-.32.289-.407.563a.625.625,0,0,0-.066.285c0-.015.059.4.059.4.081.183.459.293.644.366.27.107.336.292.522.39.108.057.244,0,.365.026s.2.105.326.13c.319.065.553-.021.26.293-.09.1-.259.065-.255.255.339.159-.378.515-.078.8.116.109.347.04.458.152s.007.384.228.5a.941.941,0,0,1,.01.152c.108.066.058.034.13.13a.807.807,0,0,1,.47.37c.067.026.035.066.081.157.015.029-.045.106-.028.156s.114.027.126.062a1.283,1.283,0,0,1,.068.526c.258.034.529.08.521.391.26.034.207-.256.281-.419a1.7,1.7,0,0,1,.293-.4c.187-.224.063-.169.366-.251.192-.052.385-.061.4-.321a2.682,2.682,0,0,0,1.085-.388.946.946,0,0,0,.474-.341c.162-.253.025-.274.06-.507-.312-.115.051-.5-.316-.568.107-.377.766-.132.815-.476a1.091,1.091,0,0,0,.54-.308.463.463,0,0,0,.105-.55c-.051-.1-.143-.184-.2-.289s.041-.094-.09-.233c-.161-.17-.417-.105-.469-.351-.069-.323.308-.288.53-.357.36-.111.286-.271.512-.522.083-.093.245-.093.3-.17.081-.107.027-.3.093-.413s.176-.114.23-.264a.994.994,0,0,0,.06-.288c-.055-.056.03-.371.006-.526-.036-.238-.18-.414-.1-.646-.045-.01-.074-.033-.119-.044.133-.357-.23-.384-.462-.451l-.012,0c-.009-.02-.018-.038-.027-.053a1.863,1.863,0,0,0-.288-.358c-.12-.124-.286-.146-.33-.328-.176-.056-.977.1-.639-.356.111-.149.343-.07.482-.138.215-.106.16-.1.233-.352.068.028.176,0,.249.021.09-.2-.013-.47.076-.647.043-.085.216-.151.287-.227a.706.706,0,0,0,.165-.292,1.319,1.319,0,0,1,.35-.522.586.586,0,0,0,.263-.548c-.047,0-.106-.014-.153-.01-.021-.177.146-.247.163-.414.428-.086.183-.418.319-.658.068-.118.271-.13.321-.233.065-.133-.1-.3-.053-.476a.779.779,0,0,0,.674-.725c-.028-.012-.06-.022-.089-.036-.012-.324.264-.606.33-.939.058-.289.261-.782.116-1.037-.323-.05-.2.34-.327.476-.16.167-.514-.046-.52.262-.29.032-.358.426-.621.519-.238.084-.676-.1-.682.361-.31-.039-1.144.455-1.26-.022.15-.065.815-.426.258-.468a.361.361,0,0,0-.041-.346c-.376-.054-.47.454-.684-.066-.127,0-.225.017-.348.023.017-.31-.057-.319-.232-.51-.114-.124-.087-.011-.164-.208a3.326,3.326,0,0,1-.07-.478.9.9,0,0,1-.492-.192c-.064-.075-.012-.219-.062-.272-.079-.084-.2-.052-.288-.094-.308-.149-.619-.206-.94-.365.131-.335-.4-.234-.552-.325-.324-.2-.174-.386.06-.483.183-.076.579.035.479-.154-.149-.282-.413-.057-.637-.111-.129-.236.181-.38.493-.526.166.082.295.331.381.433.1.119.358.245.331.451a.367.367,0,0,1,.392.228,2.628,2.628,0,0,1,1.2.43c.2.091,1.147.421,1.146.547.424.047.325.391.26.685.327.017-.1.512.321.656a1.344,1.344,0,0,0,.945-.13,4.4,4.4,0,0,1,.554-.163c.093-.023.211-.01.293-.073.152-.117.032-.133.1-.219.176-.24.5-.379.721-.62-.2-.2.161-.442.222-.654-.363-.007-.294-.405-.23-.644-.054.019-.166,0-.219.022,0-.116.312-1.026-.162-.586.018-.293-.154-.157-.3-.192-.248-.061-.162.052-.258-.227-.071-.207-.162-.671-.485-.581-.095.233-.043.666-.463.614-.141-.018-.134-.171-.259-.2-.169-.037-.2.081-.367,0-.191-.091-.322-.427-.448-.555-.167-.168-.545-.212-.4-.548-.335-.044-.149-.612.2-.5.234.077.184.485.579.333.014.247-.009.289.135.419.109.1.245.012.331.222.245.073.366-.2.608-.184a1.538,1.538,0,0,0,.435.354,1.949,1.949,0,0,0,.672-.008c.118-.048.073-.195.177-.247s.194.015.285,0c.2-.041.547-.2.462.22a2.185,2.185,0,0,1,.492.078c.3.02.233-.062.443.16-.038.332.931.4,1.169.357.143.159.422.106.372.381.223.094.026.212.085.364.065.168.157.125.326.27.042.036.057.145.069.155a1.219,1.219,0,0,0,.2.1.607.607,0,0,1,.135.452.68.68,0,0,1,.516.69c0,.145-.1.275-.041.4.095.2.226.092.358.195.275.216.163.459.4.624v-2.5c-.271-.1.059-.4-.107-.6-.116-.141-.524-.153-.669-.276a.969.969,0,0,1-.169-.285c-.063-.1-.244-.12-.158-.319.048-.11.223-.059.286-.169s-.01-.283.038-.419c.046.006.107-.014.153-.01.011-.19-.069-.5.228-.414-.034.241.037.635.325.62.13.261-.174.4.062.622.1.091.259.008.344.113.057.07.026.271.029.362.323.136.343.565.739.489-.025-.1-.011-.171-.1-.256.223-.228.172.139.206.2.064.107.177.184.223.323a4.339,4.339,0,0,1,.022.434c.029.135.141.189.112.376C339.962,303.176,340.579,303.731,340.832,303.769ZM325.5,298.19c-.334-.373-.241.222-.431.322s-.3-.095-.45-.125-.292.037-.424,0c-.256-.081-.373-.309-.584-.458-.175-.124-.218-.018-.3-.2-.034-.07.257-.166-.018-.224a.7.7,0,0,0-.01-.153c-.2-.023-.579.208-.619-.033a6.047,6.047,0,0,1-.643-.01c.092-.394.471-.4.812-.451.3-.042.659-.138.943-.188.088-.016.345-.1.389-.1.152.012.244.121.385.165.175.055.222.027.375-.066.068-.041.153-.345.284-.105l.163.065c.039.044.081.043.07.125.039,0,.081.008.12.01.009.05.023.11.033.152-.051.033-.052.065-.09.1.078.005.119.052.188.067-.036.206-.722.185-.289.394.272.131.656-.041.941,0-.015.038-.016.087-.025.12.14-.014.191.014.229.13l.054.011C326.661,298.406,325.587,297.677,325.5,298.19Zm2.905.256c-.359-.169-.267-.3-.333-.644-.061-.324-.45-.391-.428-.712-.2-.017-.417-.079-.359-.326-.244.055-.285-.1-.381-.239.021-.157.15-.422-.067-.489.111-.191.279-.221.2-.476.229-.017.325-.231.543-.272-.006-.045.015-.107.011-.153a4.543,4.543,0,0,1,.479,0c.028.055-.024.037-.028.06l.032.2c.206.374-.552.506-.5.824.078.453.744.465,1.111.484a.306.306,0,0,0,.155.353c-.425.231.276.468.464.461,0,.046.016.107.01.153.17,0,.314-.113.478-.022-.091.412.411.25.14.673a.476.476,0,0,1,.392.2C329.854,298.978,328.9,298.678,328.406,298.446Z",
    transform: "translate(-305.232 -291.644)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122536",
    "data-name": "Path 122536",
    d: "M367.808,358.248a.448.448,0,0,0,.532-.131c.062-.065.076-.188.129-.238s.21-.06.263-.127,0-.219.061-.289c.082-.089.217-.043.3-.121.185-.167.082-.318.122-.554.066-.387.473-.416.813-.6.148-.082.376-.161.269-.349-.1-.171-.326-.021-.516-.071.038-.3.115-.332-.261-.391a.312.312,0,0,1,.318-.358c-.042-.085,0-.168-.024-.251.327-.007.257-.435.288-.625a3.25,3.25,0,0,0,.1-.357c.01-.126-.052-.263-.041-.351.025-.231.216-1.22-.246-1.348a1.279,1.279,0,0,0-.168-.19l-.2.033c.277.354.126.374-.033.684-.105.205.019.537-.121.725-.081.108-.273.13-.369.22a1.561,1.561,0,0,0-.235.358c-.05.1-.076.283-.128.359-.106.152-.264.163-.384.276-.267.249-.171.431-.106.71a1.8,1.8,0,0,1,.01.74c-.027.128-.1.264-.132.391,0,.01-.085.212-.093.17.012.069.125.151.127.18a2.472,2.472,0,0,1-.132.757C367.9,357.716,367.943,358.066,367.808,358.248Z",
    transform: "translate(-341.337 -331.144)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122537",
    "data-name": "Path 122537",
    d: "M298.21,354.107c-.076-.089-.136-.26-.211-.366a7.779,7.779,0,0,0-.471-.636c-.2-.228-.5-.392-.62-.66-.106-.24-.1-.628-.41-.723.039-.247-.185-.356-.141-.608a.865.865,0,0,1-.386-.266,1.074,1.074,0,0,1-.169-.448c-.018-.061-.125-.1-.149-.2,0,0,.054-.19.058-.2.055-.2.016-.229.228-.328.193-.09.265.087.358-.159a.9.9,0,0,0-.106-.417c-.138-.315-.14-.516-.514-.543-.155-.105-.083-.2-.136-.345a6.182,6.182,0,0,1-.221-.651c-.029-.115.007-.328-.063-.425s-.2-.071-.272-.152c-.258-.282-.083-.295.074-.465a.547.547,0,0,0,.156-.254s-.072-.086-.054-.138.131-.064.151-.1a1.715,1.715,0,0,0,.276-.67c.018-.26-.145-.416-.171-.66-.03-.287.108-.381-.2-.611-.151-.111-.547-.164-.584-.329-.227-.05-.548.265-.554-.13-.361-.11-.327.355-.64.283-.074-.2-.3-.7-.521-.75-.04-.211.24-.77-.2-.683,0-.114-.007-.234-.01-.348-.091-.057-.071-.025-.093-.136-.076-.4.195-1.036-.252-1.311-.194-.119-.415.069-.62-.1-.176-.142-.161-.536-.13-.737a1.149,1.149,0,0,0-.106-.755c-.106-.274-.025-.47-.1-.749-.111-.431-.164-.848-.26-1.308a18.358,18.358,0,0,0,7.05,17.323c.125.01.251.01.365.012C298.454,354.252,298.312,354.227,298.21,354.107Z",
    transform: "translate(-290.948 -321.4)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122538",
    "data-name": "Path 122538",
    d: "M354.471,384.51v-.043a.915.915,0,0,1-.191.369.546.546,0,0,0-.179.308.794.794,0,0,1-.088.191s-.119.164-.106.154c-.082.062-.2.076-.283.155-.124.125-.1.178-.283.261a1.731,1.731,0,0,1-.391.165c-.343.053-.3-.39-.6-.34-.044.1-.168.1-.26.145-.092-.156-.216-.085-.348-.058a1,1,0,0,1-.612.534c-.214.049-.178-.031-.369-.06a.547.547,0,0,0-.24.049c-.089.06-.06.119-.13.169-.118.084-.246.089-.368.168a2.036,2.036,0,0,1-.374.26c-.193.071-.373.058-.561.141a2.91,2.91,0,0,0-.5.166.36.36,0,0,0-.236-.081c.008.036-.012.088-.007.124-.115,0-.168.1-.257.156-.053.035-.1.017-.157.06a.3.3,0,0,0-.1.13c.138.027.079.079.057.174,0-.011-.136.2-.131.2-.146.1-.494.082-.565-.1-.087.087-.25.108-.3.211a3.2,3.2,0,0,0-.344-.127c-.211-.034-.254.072-.412.126-.247.085-.5-.077-.736-.021-.019-.2-.211-.17-.18.021a.508.508,0,0,0-.285.043.321.321,0,0,0-.319.006c-.221-.219-.851.274-1.044.43-.043.035-.04.119-.084.16s-.109.048-.153.086c-.075.066-.134.133-.212.194-.048.038-.12.1-.187.143a18.258,18.258,0,0,0,11.25-3.521l.095-.071a1.456,1.456,0,0,1,.041-.292c.025-.079.3-.277.046-.286.13-.093.047-.139.068-.234S354.517,384.6,354.471,384.51Z",
    transform: "translate(-325.028 -352.498)",
    fill: "#3989b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122539",
    "data-name": "Path 122539",
    d: "M322.648,300.139s.428-.2.457-.221c.142-.111.039-.343.319-.3.156-.281.321-.439.467-.706.081-.013.1-.068.157-.1l.163-.163a3.775,3.775,0,0,1-.814.384c-.145.032-.252,0-.39.041-.324.084-.163.1-.295.324C322.629,299.538,322.2,300.088,322.648,300.139Z",
    transform: "translate(-311.598 -296.235)",
    fill: "#3989b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_116485",
    "data-name": "Group 116485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116484",
    "data-name": "Group 116484",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122540",
    "data-name": "Path 122540",
    d: "M220.083,297.711a15.8,15.8,0,1,1-22.072-3.446A15.8,15.8,0,0,1,220.083,297.711Z",
    transform: "translate(-225.766 -291.37)",
    opacity: 0.5,
    fill: "url(#radial-gradient-2)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122541",
    "data-name": "Path 122541",
    d: "M221.891,301.826a14.146,14.146,0,1,1-19.766-3.087A14.146,14.146,0,0,1,221.891,301.826Z",
    transform: "translate(-228.908 -294.511)",
    opacity: 0.5,
    fill: "url(#radial-gradient-3)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_122543",
    "data-name": "Path 122543",
    d: "M313.458,292.837a11.241,11.241,0,0,0-5.782,6.565c-2.136,6.8,3.155,14.512,11.817,17.234,7.829,2.461,15.732,0,18.757-5.514a18.339,18.339,0,0,0-24.793-18.286Z",
    transform: "translate(-301.603 -291.65)",
    fill: "#e9f8ff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.ac555273fc13a83abd153fa9e81731cc.svg";
export { ForwardRef as ReactComponent };